"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const reportGraphType = (state = 'opened', action) => {
    switch (action.type) {
        case 'UPDATE_REPORT_GRAPH_TYPE':
            return action.reportGraphType;
        default:
            return state;
    }
};
exports.getReportGraphType = (state) => state.reportGraphType;
exports.default = reportGraphType;
